import React, { useLayoutEffect, useRef } from 'react';
import { useResizeObserver } from '@atlassian/jira-react-use-resize-observer';
import { useEvent } from '@atlassian/jira-software-react-use-event';
import type { SwimlaneId } from '../../../../model/issue/issue-types';
import { useIsIncrementPlanningBoard } from '../../../../state/state-hooks/capabilities';
import ColumnsContainer from '../columns-container';
import Swimlane from '../swimlane';
import { SwimlaneMoveToDoneButton } from '../swimlane-move-to-done';

const VirtualizedSwimlane = ({
	id,
	index,
	top,
	measure,
	forceRemeasure,
	isLastSwimlane,
	isUnscheduledWorkColumnPanel,
}: {
	id: SwimlaneId;
	index: number;
	top: number;
	measure: (el: Element | null) => void;
	forceRemeasure: (el?: Element | null) => void;
	isLastSwimlane: boolean;
	isUnscheduledWorkColumnPanel: boolean;
}) => {
	const wrapperRef = useRef<HTMLDivElement>(null);
	const onResize = useEvent(() => {
		forceRemeasure(wrapperRef.current);
	});
	useLayoutEffect(() => {
		if (wrapperRef.current) {
			measure(wrapperRef.current);
		}
	}, [wrapperRef, measure]);

	useResizeObserver({
		ref: wrapperRef,
		onResize,
	});
	const isIPBoard = useIsIncrementPlanningBoard();

	return (
		<Swimlane
			id={id}
			key={id}
			isFirstSwimlane={index === 0}
			wrapperStyle={{
				position: 'absolute',
				width: '100%',
				top,
			}}
			innerRef={wrapperRef}
			customRightContent={<SwimlaneMoveToDoneButton id={id} />}
			hasShadow={!isIPBoard}
			isUnscheduledWorkColumnPanel={isUnscheduledWorkColumnPanel}
		>
			<ColumnsContainer
				swimlaneId={id}
				isLastSwimlane={isLastSwimlane}
				columnPlaceholder={null}
				offsetTop={top}
				isUnscheduledWorkColumn={isUnscheduledWorkColumnPanel}
			/>
		</Swimlane>
	);
};

export default VirtualizedSwimlane;
